<template>
  <v-app>
    <Navbar :voltar="true" app />
    <Sidebar />
    <v-main>
      <v-container class="container" fluid>
        <v-row justify="center">
          <v-col cols="12" class="px-12">
        <v-overlay v-model="loading" class="align-center justify-center">
          <v-progress-circular
            color="primary"
            indeterminate
            size="64"
          ></v-progress-circular>
        </v-overlay>
        <v-row class="mb-4">
          <v-col cols="12">
            <v-card
              class="mx-auto header-card"
              elevation="3"
              style="background: #343f53"
            >
              <v-card-title
                class="d-flex align-center justify-space-between pa-6"
              >
                <div class="d-flex align-center">
                  <v-icon color="white" size="32" class="mr-3"
                    >mdi-church</v-icon
                  >
                  <span class="text-h4 font-weight-bold text-white"
                    >Painel de Capelas</span
                  >
                </div>
                <v-select
                  v-model="unidadeFiltro"
                  :items="unidadesFiltro"
                  item-title="nome"
                  item-value="sigla"
                  placeholder="Filtrar Unidade"
                  variant="outlined"
                  density="compact"
                  hide-details
                  clearable
                  class="ml-4"
                  style="max-width: 300px; background: white; border-radius: 8px;"
                  prepend-inner-icon="mdi-filter"
                ></v-select>
              </v-card-title>
            </v-card>
          </v-col>
        </v-row>

        <!-- Grid de Unidades -->
        <v-row>
          <v-col
            v-for="unidade in unidadesFiltradas"
            :key="unidade.nome"
            cols="12"
            lg="6"
            xl="6"
          >
            <v-card
              class="unidade-card mb-4"
              variant="outlined"
              color="#343F53"
              elevation="2"
            >
              <div
                :style="{ background: getColor(unidade.sigla) }"
                style="height: 1vh"
              ></div>
              <!-- Header da Unidade -->
              <v-card-title
                class="d-flex align-center pa-4"
                style="color: #343f53"
              >
                <v-avatar
                  :color="getColor(unidade.sigla)"
                  size="48"
                  class="mr-3 elevation-0"
                >
                  <span
                    class="text-h6 font-weight-bold"
                    style="color: #343f53"
                    >{{ unidade.sigla }}</span
                  >
                </v-avatar>
                <div class="flex-grow-1">
                  <div class="text-h6 font-weight-bold">{{ unidade.nome }}</div>
                  <div class="text-caption opacity-90">
                    {{ getUnidadeStats(unidade.nome) }}
                  </div>
                </div>
              </v-card-title>

              <!-- Grid de Capelas -->
              <v-card-text class="pa-4 mx-4">
                <v-row dense>
                  <v-col
                    v-for="capela in getCapelasVisiveis(unidade.nome)"
                    :key="capela"
                    cols="12"
                    sm="6"
                    md="12"
                    lg="6"
                  >
                    <v-card
                      class="capela-preview-card mb-3"
                      elevation="0"
                      @click="abrirDialogDespedidas(unidade.nome, capela)"
                      :style="{
                        cursor: 'pointer',
                        transition: 'all 0.3s',
                        borderRadius: '16px',
                        border: `1px solid ${getColor(unidade.sigla)}`,                        
                        background: `${getColor(unidade.sigla)}15`
                      }"
                    >
                      <!-- Header da Capela -->
                      <v-card-title class="d-flex align-center pa-3" :style="{ background: 'transparent', borderRadius: '16px 16px 0 0' }">
                        <v-icon size="20" class="mr-2" color="#343f53">mdi-church-outline</v-icon>
                        <span class="text-subtitle-1 font-weight-bold" style="color: #343f53">
                          Capela {{ capela }}
                        </span>
                        <v-spacer></v-spacer>
                        <v-chip
                          v-if="getNumDespedidas(unidade.nome, capela) > 0"
                          size="small"
                          color="orange"
                          variant="flat"
                        >
                          Em Operação
                        </v-chip>
                        <v-chip
                          v-else
                          size="small"
                          color="success"
                          variant="flat"
                        >
                          Disponível
                        </v-chip>
                      </v-card-title>

                      <!-- Preview das Despedidas -->
                      <v-card-text class="pa-3 pt-2">
                        <div v-if="getNumDespedidas(unidade.nome, capela) > 0">
                          <div
                            v-for="despedida in getDespedidasCapela(unidade.nome, capela).slice(0, 2)"
                            :key="despedida.id"
                            class="despedida-preview mb-2 pa-2"
                            :style="{
                              background: 'white',
                              borderRadius: '12px',
                              borderLeft: `4px solid ${getColor(unidade.sigla)}`
                            }"
                          >
                            <div class="text-body-2 font-weight-bold" style="color: #343F53;">
                              {{ despedida.nomeFalecido }}
                            </div>
                            <div class="text-caption text-medium-emphasis">
                              {{ formatTimeRange(despedida.dataHoraInicial, despedida.dataHoraFinal) }}
                            </div>
                          </div>
                          
                          <!-- Ver detalhes -->
                          <v-btn
                            variant="text"
                            size="small"
                            color="#343F53"
                            class="mt-1"
                            prepend-icon="mdi-chevron-down"
                          >
                            Ver detalhes
                          </v-btn>
                        </div>
                        
                        <div v-else class="text-center py-3">
                          <v-icon size="32" color="grey-lighten-1">mdi-church-outline</v-icon>
                          <div class="text-caption text-medium-emphasis mt-1">
                            Nenhuma despedida agendada
                          </div>
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
                
                <!-- Botão Ver Mais -->
                <div v-if="capelasPorUnidade[unidade.nome].length > 4" class="text-center mt-2">
                  <v-btn
                    variant="text"
                    :color="getColor(unidade.sigla)"
                    @click="toggleUnidadeExpandida(unidade.nome)"
                    prepend-icon="mdi-chevron-down"
                  >
                    {{ unidadesExpandidas[unidade.nome] ? 'Ver menos' : `Ver mais (${capelasPorUnidade[unidade.nome].length - 4})` }}
                  </v-btn>
                </div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <!-- Dialog Melhorado -->
        <v-dialog
          v-model="dialogDespedidas"
          max-width="1000"
          min-height="300"
          persistent
          transition="dialog-bottom-transition"
        >
          <v-card class="dialog-card">
            <!-- Header do Dialog -->
            <v-toolbar color="#343F53" dark elevation="0">
              <v-toolbar-title class="text-h5 font-weight-bold">
                <v-icon class="mr-4">mdi-church</v-icon>
                {{ selectedUnidade }} - {{ selectedCapela }}
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn
                icon="mdi-close"
                @click="dialogDespedidas = false"
                variant="text"
              ></v-btn>
            </v-toolbar>

            <!-- Conteúdo do Dialog -->
            <v-card-text class="pa-0">
              <v-expansion-panels
                v-if="
                  getDespedidasCapela(selectedUnidade, selectedCapela).length >
                  0
                "
                class="mt-0"
                elevation="0"
              >
                <v-expansion-panel
                  v-for="despedida in getDespedidasCapela(
                    selectedUnidade,
                    selectedCapela
                  )"
                  :key="despedida.id"
                  elevation="0"
                >
                  <v-expansion-panel-title
                    class="py-4"
                    @click="initEditingDespedida(despedida)"
                  >
                    <div class="d-flex align-center w-100">
                      <div class="flex-grow-1">
                        <div class="text-h6">
                          {{ despedida.nomeFalecido }}
                        </div>
                        <div class="text-body-2 text-medium-emphasis">
                          {{ formatDate(despedida.dataHoraInicial) }}
                        </div>
                      </div>

                      <v-chip
                        :color="getStatusColor(despedida)"
                        variant="flat"
                        size="small"
                        class="mr-2"
                      >
                        {{ getStatusText(despedida) }}
                      </v-chip>
                    </div>
                  </v-expansion-panel-title>

                  <v-expansion-panel-text class="pa-0">
                    <v-form>
                      <v-row>
                        <v-col cols="12" md="6">
                          <v-select
                            v-model="editingDespedida.empresa"
                            :items="unidades"
                            item-title="nome"
                            item-value="sigla"
                            label="Unidade"
                            variant="outlined"
                            density="comfortable"
                            prepend-inner-icon="mdi-domain"
                          ></v-select>
                        </v-col>

                        <v-col cols="12" md="6">
                          <v-select
                            :items="capelasPorUnidade[selectedUnidade]"
                            label="Número da Capela"
                            v-model="editingDespedida.capela"
                            variant="outlined"
                            density="comfortable"
                            prepend-inner-icon="mdi-church-outline"
                          ></v-select>
                        </v-col>

                        <v-col cols="12" md="6">
                          <v-text-field
                            v-model="editingDespedida.dataHoraInicial"
                            label="Data e Hora Inicial"
                            type="datetime-local"
                            variant="outlined"
                            density="comfortable"
                            prepend-inner-icon="mdi-calendar-start"
                          ></v-text-field>
                        </v-col>

                        <v-col cols="12" md="6">
                          <v-text-field
                            v-model="editingDespedida.dataHoraFinal"
                            label="Data e Hora Final"
                            type="datetime-local"
                            variant="outlined"
                            density="comfortable"
                            prepend-inner-icon="mdi-calendar-end"
                          ></v-text-field>
                        </v-col>

                        <v-col cols="12">
                          <div
                            class="d-flex align-center justify-space-between"
                          >
                            <v-switch
                              v-model="editingDespedida.status"
                              :label="
                                editingDespedida.status ? 'Ativo' : 'Inativo'
                              "
                              :color="
                                editingDespedida.status ? 'success' : 'error'
                              "
                              inset
                              hide-details
                            ></v-switch>
                            <div>
                              <v-btn
                                :href="getUrlCapela(editingDespedida.empresa, editingDespedida.capela)"
                                target="_blank"
                                variant="outlined"
                                color="#343F53"
                                prepend-icon="mdi-open-in-new"
                                class="mr-2"
                              >
                                Visualizar
                              </v-btn>
                              <v-btn
                                color="#343F53"
                                variant="flat"
                                prepend-icon="mdi-content-save"
                                @click="salvarCapela(editingDespedida)"
                                class="font-weight-bold"
                              >
                                Salvar Alterações
                              </v-btn>
                            </div>
                          </div>
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-expansion-panel-text>
                </v-expansion-panel>
              </v-expansion-panels>

              <!-- Estado vazio -->
              <div
                v-else
                class="d-flex flex-column align-center justify-center pa-12 text-center"
              >
                <v-icon size="64" color="grey-lighten-1" class="mb-4"
                  >mdi-church-outline</v-icon
                >
                <div class="text-h6 text-medium-emphasis mb-2">
                  Capela Vazia
                </div>
                <div class="text-body-2 text-medium-emphasis">
                  Nenhuma despedida agendada para esta capela
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-dialog>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
    <Footer />
  </v-app>
</template>

<script>
import dayjs from "dayjs";
import { http } from "@/services/config";
import authHeader from "@/services/auth-header";
import { useToast } from "vue-toastification";
import Sidebar from "@/components/restrito/Sidebar.vue";
import Navbar from "@/components/restrito/Navbar.vue";
const toast = useToast();
import Footer from "./Footer.vue";
export default {
  name: "PainelDespedidas",
  components: {
    Navbar,
    Sidebar,
    Footer,
  },
  data() {
    return {
      unidades: [
        { nome: "Central de Velórios", sigla: "CV" },
        { nome: "Parque das Flores", sigla: "PF" },
        { nome: "Memorial Parque Maceió", sigla: "ME" },
        { nome: "Cemitério Previda", sigla: "CP" },
        { nome: "Parque do Agreste", sigla: "AM" },
      ],
      capelasPorUnidade: {
        "Memorial Parque Maceió": ["01", "02", "03", "04", "05", "06", "07"],
        "Central de Velórios": ["01", "02", "03", "04"],
        "Parque das Flores": ["01", "02", "03", "04"],
        "Cemitério Previda": ["01", "02", "03"],
        "Parque do Agreste": ["01", "02", "03"],
      },
      dialogDespedidas: false,
      selectedUnidade: "",
      selectedCapela: "",
      despedidas: [],
      loading: false,
      unidadeFiltro: null,
      unidadesExpandidas: {},
      editingDespedida: {
        id: 0,
        id_despedida: 0,
        empresa: "",
        capela: "",
        dataHoraInicial: "",
        dataHoraFinal: "",
        status: true,
      },
    };
  },
  computed: {
    unidadesFiltro() {
      return [
        { nome: "Todas as Unidades", sigla: null },
        ...this.unidades
      ];
    },
    unidadesFiltradas() {
      if (!this.unidadeFiltro) {
        return this.unidades;
      }
      return this.unidades.filter(u => u.sigla === this.unidadeFiltro);
    },
    getUrlCapela() {
      return (empresa, capela) => {
        if (typeof window !== 'undefined') {
          return `${window.location.origin}/capela/${empresa}/${capela}`;
        }
        return `https://parquedasrecordacoes.com.br/capela/${empresa}/${capela}`;
      };
    }
  },
  mounted() {
    this.consultarDespedida();
  },
  methods: {
    getStatusColor(despedida) {
      if (!despedida.status) return "error";
      const dataInicial = new Date(despedida.dataHoraInicial);
      const agora = new Date();
      return dataInicial > agora ? "grey" : "success";
    },
    getStatusText(despedida) {
      if (!despedida.status) return "Inativo";
      const dataInicial = new Date(despedida.dataHoraInicial);
      const agora = new Date();
      return dataInicial > agora ? "Agendado" : "Ativo";
    },
    abrirDialogDespedidas(unidade, capela) {
      this.selectedUnidade = unidade;
      this.selectedCapela = capela;
      this.editingDespedida = {
        id: 0,
        id_despedida: 0,
        empresa: "",
        capela: "",
        dataHoraInicial: "",
        dataHoraFinal: "",
        status: true,
      };
      this.dialogDespedidas = true;
    },
    getNumDespedidas(unidade, capela) {
      const sigla = this.unidades.find((u) => u.nome === unidade)?.sigla;
      return this.despedidas.filter(
        (d) => d.empresa === sigla && d.capela === capela
      ).length;
    },
    getTotalDespedidasUnidade(unidade) {
      const sigla = this.unidades.find((u) => u.nome === unidade)?.sigla;
      return this.despedidas.filter((d) => d.empresa === sigla).length;
    },
    getUnidadeStats(unidade) {
      const total = this.capelasPorUnidade[unidade]?.length || 0;
      const ocupadas =
        this.capelasPorUnidade[unidade]?.filter(
          (capela) => this.getNumDespedidas(unidade, capela) > 0
        ).length || 0;
      return `${ocupadas}/${total} capelas ocupadas`;
    },
    getDespedidasCapela(unidade, capela) {
      const sigla = this.unidades.find((u) => u.nome === unidade)?.sigla;
      return this.despedidas.filter(
        (d) => d.empresa === sigla && d.capela === capela
      );
    },
    formatDate(date) {
      return dayjs(date).format("DD/MM/YYYY");
    },
    formatTimeRange(dataInicial, dataFinal) {
      const horaInicial = dayjs(dataInicial).format("HH:mm");
      const horaFinal = dayjs(dataFinal).format("HH:mm");
      return `${horaInicial} - ${horaFinal}`;
    },
    getCapelasVisiveis(unidade) {
      const capelas = this.capelasPorUnidade[unidade] || [];
      if (capelas.length <= 4 || this.unidadesExpandidas[unidade]) {
        return capelas;
      }
      return capelas.slice(0, 4);
    },
    toggleUnidadeExpandida(unidade) {
      this.unidadesExpandidas[unidade] = !this.unidadesExpandidas[unidade];
      this.$forceUpdate();
    },
    getColor(sigla) {
      switch (sigla) {
        case "PF":
          return "#FF9800";
        case "CP":
          return "#2196F3";
        case "ME":
          return "#4CAF50";
        case "AM":
          return "#FF9800";
        case "CV":
          return "#1976D2";
        default:
          return "#343F53";
      }
    },
    // Consultar despedidas vinculadas as capelas
    consultarDespedida() {
      this.loading = true;
      http
        .get("/apresentacao/lista-vencer", { headers: authHeader() })
        .then((response) => {
          this.despedidas = response.data;
        })
        .catch((error) => {
          console.error(error);
          toast.error("Erro ao carregar as despedidas");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    initEditingDespedida(despedida) {
      this.editingDespedida = {
        id: despedida.id,
        id_despedida: despedida.id_despedida,
        empresa: despedida.empresa,
        capela: despedida.capela,
        dataHoraInicial: despedida.dataHoraInicial,
        dataHoraFinal: despedida.dataHoraFinal,
        status: despedida.status,
      };
    },

    async salvarCapela(despedida) {
      if (
        !despedida.empresa ||
        !despedida.capela ||
        !despedida.id_despedida ||
        !despedida.dataHoraInicial ||
        !despedida.dataHoraFinal
      ) {
        toast.error("Preencha todos os campos obrigatórios!");
        return;
      }

      await this.atualizarCapela(this.editingDespedida);
    },

    // Atualizar capela já existente
    async atualizarCapela(despedida) {
      try {
        await http.put("apresentacao/update", despedida, {
          headers: authHeader(),
        });

        this.dialogDespedidas = false;
        toast.success("Capela editada com sucesso!");
        this.consultarDespedida();
      } catch (error) {
        if (
          error.response.status === 400 &&
          error.response.data ==
            "Já existe outro registro ativo para esta empresa"
        ) {
          toast.error("Capela já vinculada a outra cerimônia!");
        } else {
          toast.error("Erro ao editar capela.");
        }
        console.error("Erro ao editar capela:", error);
      }
    },
  },
};
</script>

<style scoped>
.v-main {
  background-color: #f5f5f5;
}
.container {
  min-height: 78vh !important;
  padding-top: 2rem;
}

.unidade-card {
  border-radius: 16px !important;
  overflow: hidden;
  transition: all 0.3s ease;
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.unidade-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15) !important;
}

.capela-btn {
  border-radius: 12px !important;
  height: 80px !important;
  font-weight: bold;
}

.dialog-card {
  border-radius: 10px !important;
  overflow: hidden;
}

@media (max-width: 768px) {
  .capela-btn {
    height: 70px !important;
  }

  .text-h4 {
    font-size: 1.5rem !important;
  }
}
</style>
